import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { Button, Input, Alert } from '../../components/ui';
import api from '../../services/api';

export default function ClientLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotSent, setForgotSent] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const { login, loading } = useAuthStore();
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    if (!form.email || !form.password) return setError('Email and password required');
    const result = await login(form.email, form.password, false);
    if (result.success) {
      if (!result.user) { setError('Login failed. Please try again.'); return; }
      if (result.user.role === 'superadmin') { setError('Please use the admin login page.'); return; }
      navigate('/client/dashboard');
    } else setError(result.message);
  };

  const handleForgotPassword = async () => {
    if (!forgotEmail) return;
    setForgotLoading(true);
    try {
      await api.post('/auth/forgot-password-request', { email: forgotEmail });
      setForgotSent(true);
    } catch { setForgotSent(true); } // Always show success for security
    finally { setForgotLoading(false); }
  };

  if (showForgot) return (
    <div style={{ minHeight: '100vh', background: 'var(--page-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ marginBottom: 8 }}><span style={{ fontSize: 28, fontWeight: 900, color: "#2ECC71", letterSpacing: -1 }}>MARK</span><span style={{ fontSize: 13, fontWeight: 500, color: "#666", marginLeft: 8 }}>Ms Discoveries</span></div>
        </div>
        <div style={{ background: 'var(--surface-1)', border: '1px solid rgba(46,204,113,0.15)', borderRadius: 20, padding: 36 }}>
          {forgotSent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 56, marginBottom: 16 }}>📬</div>
              <h3 style={{ color: '#2ECC71', marginBottom: 12 }}>Request Sent!</h3>
              <p style={{ color: '#888', fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>Your password reset request has been sent to our admin team. Our admin will reset your password and send it to your registered email address within working hours (Mon–Sat, 10AM–6PM).</p>
              <Button fullWidth onClick={() => { setShowForgot(false); setForgotSent(false); setForgotEmail(''); }}>Back to Login</Button>
            </div>
          ) : (
            <>
              <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Forgot Password</h2>
              <p style={{ color: '#666', fontSize: 13, marginBottom: 24 }}>Enter your registered email. Our admin will reset your password and send it to you.</p>
              <Input label="Registered Email" type="email" placeholder="your@company.com" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} />
              <Button fullWidth loading={forgotLoading} onClick={handleForgotPassword} style={{ marginBottom: 12 }}>Send Reset Request</Button>
              <Button fullWidth variant="ghost" onClick={() => setShowForgot(false)}>Back to Login</Button>
            </>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'var(--page-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ position: 'fixed', top: '20%', left: '50%', transform: 'translateX(-50%)', width: 400, height: 400, background: 'radial-gradient(circle, rgba(46,204,113,0.05) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ marginBottom: 8 }}><span style={{ fontSize: 30, fontWeight: 900, color: "#2ECC71", letterSpacing: -1 }}>MARK</span><span style={{ fontSize: 13, fontWeight: 500, color: "#666", marginLeft: 8 }}>Ms Discoveries</span></div>
          <p style={{ color: '#555', fontSize: 13 }}>Email Marketing Platform</p>
        </div>
        <div style={{ background: 'var(--surface-1)', border: '1px solid rgba(46,204,113,0.15)', borderRadius: 20, padding: 36, boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
          <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 6 }}>Welcome Back</h2>
          <p style={{ color: '#666', fontSize: 13, marginBottom: 28 }}>Login to your EmailMark dashboard</p>
          {error && <Alert type="danger" style={{ marginBottom: 20 }}>{error}</Alert>}
          <Input label="Email Address" type="email" placeholder="you@yourcompany.com" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
          <Input label="Password" type="password" placeholder="Enter your password" value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} />
          <div style={{ textAlign: 'right', marginTop: -8, marginBottom: 20 }}>
            <button onClick={() => setShowForgot(true)} style={{ background: 'none', border: 'none', color: '#2ECC71', fontSize: 13, cursor: 'pointer' }}>Forgot password?</button>
          </div>
          <Button fullWidth loading={loading} onClick={handleLogin} size="lg">Login →</Button>
          <div style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: '#555' }}>
            Don't have an account? <Link to="/client/register" style={{ color: '#2ECC71', fontWeight: 600 }}>Register here</Link>
          </div>
        </div>
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Link to="/" style={{ fontSize: 12, color: '#444', textDecoration: 'none' }}>← Back to website</Link>
        </div>
      </div>
    </div>
  );
}
